import styles from "./ComponentBackButton.module.scss";
import { RiArrowGoBackLine } from "react-icons/ri";
import { TbArrowBackUp } from "react-icons/tb";

const ComponentBackButton = ({ onClick = () => {} }) => {
  return (
    <button className={styles["back-button"]} onClick={onClick}>
      <RiArrowGoBackLine /> Back
    </button>
  );
};

export default ComponentBackButton;